import { Badge } from '@/components/base/badge'
import { Field, Label } from '@/components/base/fieldset'
import { Input } from '@/components/base/input'
import { Handle, Position, type Node, type NodeProps } from '@xyflow/react'

type LoadNode = Node<{ name: string, loadCurrent: number }, 'load'>

export const LoadNode = ({ data }: NodeProps<LoadNode>) => {
  return (
    <div>
      <div className="text-white border border-zinc-500 rounded-lg p-4 bg-zinc-800/75 w-100">
        <div className="grid grid-cols-1 gap-2 items-center justify-around h-full">
          <div className="text-center"><Badge color="violet">Load</Badge></div>
          <Field>
            <Label>Name</Label>
            <Input value={ data.name } />
          </Field>
          <Field>
            <Label>Load current</Label>
            <Input value={ data.loadCurrent } />
          </Field>
        </div>
      </div>
      <Handle position={ Position.Top } type="source" />
      <Handle position={ Position.Bottom } type="target" />
    </div>
  )
}
